export const mockData = {
  labels: [
    "10 Enero",
    "11 Enero",
    "12 Enero",
    "13 Enero",
    "14 Enero",
    "15 Enero",
    "16 Enero",
  ],
  datasets: [
    {
      backgroundColor: "#5AC3F0",
      borderColor: "#5AC3F0",
      borderWidth: 1,
      data: [65, 59, 80, 81, 56, 40, 25],
      barThickness: 15
    },
  ],
};